<div class="batch-create-container">

  <!-- Header -->
  <div class="page-header">
    <button mat-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon> Back
    </button>
    <span class="field-count">{{ selectedFields.length }} field(s) selected</span>
  </div>

  <!-- Step indicators -->
  <div class="steps-indicator">
    <div class="step" [class.active]="currentStep >= 1" [class.completed]="currentStep > 1">
      <span class="step-number">1</span><span class="step-label">Sample Type</span>
    </div>
    <div class="step-line" [class.active]="currentStep > 1"></div>
    <div class="step" [class.active]="currentStep >= 2" [class.completed]="currentStep > 2">
      <span class="step-number">2</span><span class="step-label">Configuration</span>
    </div>
    <div class="step-line" [class.active]="currentStep > 2"></div>
    <div class="step" [class.active]="currentStep >= 3">
      <span class="step-number">3</span><span class="step-label">Review & Create</span>
    </div>
  </div>

  <!-- Step 1: Sample Type Selection -->
  <div class="step-content" *ngIf="currentStep === 1">
    <h3>Select Sample Type</h3>
    <div class="type-cards">
      <div class="type-card" (click)="selectType('soft_tissue')" [class.selected]="sampleType === 'soft_tissue'">
        <mat-icon>eco</mat-icon>
        <h4>Soft Tissue Samples</h4>
        <p>Leaf and plant tissue analysis</p>
      </div>
      <div class="type-card" (click)="selectType('soil')" [class.selected]="sampleType === 'soil'">
        <mat-icon>terrain</mat-icon>
        <h4>Soil Samples</h4>
        <p>Soil composition analysis</p>
      </div>
    </div>
  </div>

  <!-- Step 2: Group & Starting Number -->
  <div class="step-content" *ngIf="currentStep === 2">
    <h3>Configure Samples</h3>
    <div class="config-form">
      <mat-form-field appearance="outline">
        <mat-label>Sample Group Name</mat-label>
        <input matInput [(ngModel)]="groupName" placeholder="e.g. Spring 2026 Batch" required>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Starting Sample Number</mat-label>
        <input matInput [(ngModel)]="startingNumber" placeholder="e.g. S01" required>
        <mat-hint>Increments per field (S01, S02, S03...)</mat-hint>
      </mat-form-field>

      <div class="step-actions">
        <button mat-button (click)="previousStep()">Back</button>
        <button mat-raised-button color="primary" (click)="generatePreview()" [disabled]="!groupName.trim() || !startingNumber.trim()">
          Next
        </button>
      </div>
    </div>
  </div>

  <!-- Step 3: Preview Table -->
  <div class="step-content" *ngIf="currentStep === 3">
    <p class="subtitle">Edit details before creating {{ previewRows.length }} sample(s)</p>

    <div class="preview-table-wrapper">
      <table class="preview-table">
        <thead>
          <tr>
            <th class="th-checkbox"><mat-checkbox [checked]="allSelected" [indeterminate]="someSelected" (change)="toggleSelectAll($event.checked)"></mat-checkbox></th>
            <th>Farm</th>
            <th>Field</th>
            <th>Sample Name</th>
            <ng-container *ngIf="sampleType === 'soft_tissue'">
              <th>Plant Part</th>
            </ng-container>
            <ng-container *ngIf="sampleType === 'soil'">
              <th>Sample Depth</th>
              <th>Rock %</th>
            </ng-container>
            <th>Note</th>
          </tr>
          <tr class="batch-row" *ngIf="selectedRowIds.size > 0">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <ng-container *ngIf="sampleType === 'soft_tissue'">
              <td>
                <select class="inline-select" [(ngModel)]="batchPlantPartId">
                  <option [ngValue]="null">Set...</option>
                  <option *ngFor="let pp of plantParts" [ngValue]="pp.id">{{ pp.name }}</option>
                </select>
              </td>
            </ng-container>
            <ng-container *ngIf="sampleType === 'soil'">
              <td><input class="inline-input narrow" [(ngModel)]="batchSampleDepth" placeholder="Set..."></td>
              <td><input class="inline-input narrow" [(ngModel)]="batchRockPercentage" placeholder="Set..."></td>
            </ng-container>
            <td><input class="inline-input" [(ngModel)]="batchNote" placeholder="Set..."></td>
            <td class="batch-apply-cell">
              <button mat-icon-button color="primary" (click)="applyBatchValues()" matTooltip="Apply to selected"><mat-icon>check</mat-icon></button>
              <button mat-icon-button (click)="clearBatchValues()" matTooltip="Clear"><mat-icon>close</mat-icon></button>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of previewRows; let i = index">
            <td class="td-checkbox"><mat-checkbox [checked]="selectedRowIds.has(i)" (change)="toggleRowSelection(i)"></mat-checkbox></td>
            <td>{{ row.farmName }}</td>
            <td>{{ row.fieldName }}</td>
            <td>
              <input class="inline-input" [(ngModel)]="row.sampleName">
            </td>
            <ng-container *ngIf="sampleType === 'soft_tissue'">
              <td>
                <select class="inline-select" [(ngModel)]="row.plantPartId">
                  <option [ngValue]="null">—</option>
                  <option *ngFor="let pp of plantParts" [ngValue]="pp.id">{{ pp.name }}</option>
                </select>
              </td>
            </ng-container>
            <ng-container *ngIf="sampleType === 'soil'">
              <td><input class="inline-input narrow" [(ngModel)]="row.sampleDepth" placeholder="cm"></td>
              <td><input class="inline-input narrow" [(ngModel)]="row.rockPercentage" placeholder="%"></td>
            </ng-container>
            <td><input class="inline-input" [(ngModel)]="row.note" placeholder="—"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-actions">
      <button mat-button (click)="previousStep()">Back</button>
      <button mat-raised-button color="primary" (click)="submitSamples()">
        Create Samples
      </button>
    </div>
  </div>

</div>
